import { useNeucleosWorldStore } from "~/neucleos/worldStore";
import { allModeActive } from "~/neucleos/worldSelection";
import { useWorldBrandMark } from "~/neucleos/useWorldBrandMark";
import { useWorldLivenessRollups } from "~/neucleos/useWorldLiveness";
import { useWorldUnseenSettleRollups } from "~/neucleos/useWorldUnseenSettle";
import { WorldSwitcher } from "./WorldSwitcher";

/** The same stance chooser in the space beside the dock toggle. */
export function WorldStanceSwitcher() {
  const worlds = useNeucleosWorldStore((s) => s.worlds);
  const currentWorldKey = useNeucleosWorldStore((s) => s.activeWorldKey);
  const signedIn = useNeucleosWorldStore((s) => s.signedIn);
  const localSelected = useNeucleosWorldStore((s) => s.selection?.status === "local");
  const allSelected = useNeucleosWorldStore((s) => allModeActive(s.selection));
  const brandMarkUrl = useWorldBrandMark(currentWorldKey);
  const liveness = useWorldLivenessRollups();
  const unseen = useWorldUnseenSettleRollups();
  return signedIn ? (
    <WorldSwitcher
      {...{ worlds, currentWorldKey, localSelected, allSelected, brandMarkUrl, liveness, unseen }}
    />
  ) : (
    <span className="truncate px-2 text-[11px] text-muted-foreground" data-dock-local="">
      Local
    </span>
  );
}
